import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  makeStyles,
  Box,
  Divider,
  Typography,
} from '@material-ui/core';
import ADMISSION_TYPES from 'constant/admission-types';
import STATUSES from 'constant/college-application-status';
import DatePickerLabel from 'components/common/DatePickerLabel';
import Dropdown from 'components/form/Dropdown';
import { platforms } from '../constants';
import Button from 'components/common/Button';

const GROUPS = [
  {
    value: 'reach',
    label: 'Reach',
    index: 1,
  },
  {
    value: 'target',
    label: 'Target',
    index: 2,
  },
  {
    value: 'safety',
    label: 'Safety',
    index: 3,
  },
];

const Filter = ({ filters, setFilter }) => {
  const handleChange = (name, val) => {
    setFilter({
      ...filters,
      [name]: val,
    });
  };

  const onDateChange = (date) => {
    setFilter({
      ...filters,
      app_deadline: date.format('YYYY-MM-DD'),
    });
  };

  return (
    <Box>
      <Typography paragraph variant="h5">Filters</Typography>
      <Card>
        <CardContent>
          <Typography paragraph variant="subtitle2">
            Filter by
          </Typography>
          <Box marginBottom={2}>
            <Typography gutterBottom variant="smallBold" color="textSecondary" component="p">
              Status
            </Typography>
            <Dropdown
              options={STATUSES}
              id="status"
              name="status"
              value={filters?.status}
              onChange={(val) => handleChange('status', val)}
            />
          </Box>

          <Box marginBottom={2}>
            <Typography gutterBottom variant="smallBold" color="textSecondary" component="p">
              Group
            </Typography>
            <Dropdown
              options={GROUPS}
              value={filters?.category}
              id="status"
              name="category"
              onChange={(val) => handleChange('category', val)}
            />
          </Box>
          <Box marginBottom={2}>
            <Typography gutterBottom variant="smallBold" color="textSecondary" component="p">
              Admission Type
            </Typography>
            <Dropdown
              options={ADMISSION_TYPES}
              value={filters.admission_type || null}
              id="admission_type"
              name="admission_type"
              onClick={(v) => handleChange('admission_type', v)}
            />
          </Box>
          <Box marginBottom={2}>
            <Typography gutterBottom variant="smallBold" color="textSecondary" component="p">
              Application Platform
            </Typography>
            <Dropdown
              options={platforms}
              id="app_platform"
              name="app_platform"
              value={filters?.app_platform}
              onClick={(v) => handleChange('app_platform', v)}
            />
          </Box>
          <Box marginBottom={3}>
            <Typography gutterBottom variant="smallBold" color="textSecondary" component="p">
              Application Deadline
            </Typography>
            <DatePickerLabel
              value={filters.app_deadline || null}
              onChange={onDateChange}
            />
          </Box>
          <Divider />
          <Box marginTop={3}>
            <Button fullWidth variant="outlined" size="large" color="primary" onClick={() => setFilter({})}>
              Reset
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Filter;
